export default __webpack_public_path__ + "static/media/sample_meeting_participants.29cb9b05.xlsx";